/* eslint-disable import/order */
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { issueLinkInformationResource } from '@jira/router-resources__advanced-roadmaps-settings/src/issueLinkInformationResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { arjSettingsDependenciesLegacyRedirectRoute } from '@jira/router-routes__advanced-roadmaps-settings-routes/src/arjSettingsDependenciesLegacyRedirectRoute.tsx';
import { LazyArjSettingsDependencies } from './ui/index.tsx';
import { redirectTo } from './ui/redirect.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const arjSettingsDependenciesLegacyRedirectRouteEntry: Route = createEntry(
	arjSettingsDependenciesLegacyRedirectRoute,

	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: redirectTo('/jira/plans/settings/dependencies'),
		isRedirect: true,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			issueLinkInformationResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyArjSettingsDependencies],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
